var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation, useQuery } from '@apollo/client';
import { Button, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { UPDATE_COMMUNITY } from 'common/graphql/mutations/community/update-community';
import { COMMUNITY_ACTIVITY_SETTINGS } from 'common/graphql/queries/community/community-activity-settings';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import { useFormik } from 'formik';
import SettingsForm from 'main/pages/SettingsPage/components/SettingsForm/SettingsForm';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
import history from 'store/history';
var CommunityActivitySettings = function (_a) {
    var _b, _c;
    var communityId = _a.communityId;
    var t = useTranslation().t;
    var _d = useState(false), isEditMode = _d[0], setIsEditMode = _d[1];
    var dispatch = useDispatch();
    var _e = useQuery(COMMUNITY_ACTIVITY_SETTINGS, {
        variables: {
            id: communityId
        }
    }), data = _e.data, loading = _e.loading;
    var onError = function (_a) {
        var _b, _c;
        var code = _a.code;
        var isForbidden = code.includes('forbidden');
        var text = isForbidden
            ? t('У вас нет прав на управление этим сообществом')
            : t('Произошла ошибка, обратитесь в поддержку. Ошибка: ') + code;
        dispatch(openSnackbar({
            message: text,
            severity: SnackbarSeverity.ERROR
        }));
        if (isForbidden)
            history.push(((_b = data === null || data === void 0 ? void 0 : data.community) === null || _b === void 0 ? void 0 : _b.url) ? "/community/".concat((_c = data === null || data === void 0 ? void 0 : data.community) === null || _c === void 0 ? void 0 : _c.url) : '/communities');
    };
    var onSuccess = function () {
        dispatch(openSnackbar({
            message: t('Данные сохранены'),
            severity: SnackbarSeverity.SUCCESS
        }));
        setIsEditMode(false);
    };
    var updateCommunity = function (data) {
        return useMutation(UPDATE_COMMUNITY, {
            variables: {
                updateCommunityData: {
                    id: communityId,
                    activitySettings: {
                        isAcceptActivitiesCreatedManually: data === null || data === void 0 ? void 0 : data.isAcceptActivitiesCreatedManually
                    }
                }
            },
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: COMMUNITY_ACTIVITY_SETTINGS,
                    variables: {
                        id: communityId
                    }
                },
            ]
        });
    };
    var handleExecuteMutation = useDynamicMutation(updateCommunity, onSuccess, onError).handleExecuteMutation;
    var handleSubmit = function (values) {
        handleExecuteMutation(__assign({}, values));
    };
    var formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            isAcceptActivitiesCreatedManually: (_c = (_b = data === null || data === void 0 ? void 0 : data.community) === null || _b === void 0 ? void 0 : _b.activitySettings) === null || _c === void 0 ? void 0 : _c.isAcceptActivitiesCreatedManually
        },
        onSubmit: handleSubmit,
        validateOnChange: false,
        validateOnBlur: false
    });
    var handleReset = function () {
        setIsEditMode(false);
        formik.resetForm();
    };
    if (loading)
        return _jsx(CircularProgressMui, {}, void 0);
    return (_jsx(SettingsForm, { header: _jsx(_Fragment, { children: t('Настройки тренировок в сообществе') }, void 0), content: _jsx("div", __assign({ className: "flex flex-col space-y-40 w-full pt-20" }, { children: _jsxs("form", __assign({ className: "flex flex-col xs:max-w-320 md:max-w-640", onSubmit: formik.handleSubmit, onReset: formik.handleReset }, { children: [_jsx("div", __assign({ className: "max-w-288" }, { children: isEditMode ? (_jsxs("div", __assign({ className: "flex flex-row space-x-10" }, { children: [_jsx(Button, __assign({ type: "reset", color: "secondary", onClick: function () { return handleReset(); } }, { children: t('Отмена') }), void 0), _jsx(Button, __assign({ type: "submit" }, { children: t('Сохранить') }), void 0)] }), void 0)) : (_jsx(Button, __assign({ type: "button", onClick: function () { return setIsEditMode(!isEditMode); } }, { children: t('Редактировать') }), void 0)) }), void 0), _jsx("div", __assign({ className: "pt-20" }, { children: _jsx(FormGroup, __assign({ className: "flex flex-col space-y-10" }, { children: _jsx("div", __assign({ className: "flex flex-row space-x-10 items-center" }, { children: _jsx(FormControlLabel, { className: "xs:w-140 md:w-240", disabled: !isEditMode, control: _jsx(Checkbox, { checked: formik.values['isAcceptActivitiesCreatedManually'] || false, onChange: function (e) {
                                            formik.setFieldError('isAcceptActivitiesCreatedManually', undefined);
                                            formik.setFieldValue('isAcceptActivitiesCreatedManually', e.target.checked);
                                        } }, void 0), label: t('Принимать тренировки, созданные вручную') }, void 0) }), void 0) }), void 0) }), void 0)] }), void 0) }), void 0) }, void 0));
};
export default CommunityActivitySettings;
